import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './styles.scss';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <h1 className="hero-title">Independentes por natureza</h1>
              <div className="hero-subtitle">
                <p className="itauna-meaning">"Pedra Negra" em Tupi</p>
                <p className="itauna-description">
                  <strong>ITAÚNA</strong> remonta à solidez, riqueza e segurança.
                </p>
              </div>
              <p className="hero-text">
                Somos uma consultoria de investimentos registrada na CVM.
              </p>
              <p className="hero-contact">
                Para consultar nossos planos, entre em contato:{' '}
                <a href="mailto:leonardo.leite@itaunaconsultoria.com.br">leonardo.leite@itaunaconsultoria.com.br</a>
                {' '}ou{' '}
                <a href="tel:+552139581228">(21) 3958-1228</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Missão, Visão e Valores */}
      <section className="mvv-section">
        <Container>
          <Row className="g-4">
            <Col md={4}>
              <Card className="mvv-card">
                <Card.Body>
                  <div className="mvv-icon">
                    <i className="bi bi-bullseye"></i>
                  </div>
                  <h3 className="mvv-title">Missão</h3>
                  <p className="mvv-text">
                    Cuidar da vida financeira dos nossos clientes e desenvolver soluções sob medida 
                    levando em consideração que cada indivíduo possui suas peculiaridades.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mvv-card">
                <Card.Body>
                  <div className="mvv-icon">
                    <i className="bi bi-eye"></i>
                  </div>
                  <h3 className="mvv-title">Visão</h3>
                  <p className="mvv-text">
                    Ser a empresa mais bem avaliada segundo padrões qualitativos.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mvv-card">
                <Card.Body>
                  <div className="mvv-icon">
                    <i className="bi bi-gem"></i>
                  </div>
                  <h3 className="mvv-title">Valores</h3>
                  <p className="mvv-text">
                    Exclusividade, imparcialidade, integridade e profissionalismo.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Diferenciais */}
      <section className="differentials-section">
        <Container fluid className="px-0">
          <Row className="align-items-center g-0">
            <Col lg={6} className="p-5">
              <div className="differential-content">
                <h2 className="section-title">Um dos nossos diferenciais é a liberdade</h2>
                <p className="section-text">
                  Vamos atrás das melhores soluções onde estiverem. Independente de gestora, 
                  corretora ou geografia. Trabalhamos em prol do que é melhor para nossos clientes.
                </p>
              </div>
            </Col>
            <Col lg={6} className="d-none d-lg-block">
              <div className="differential-icon-large">
                <i className="bi bi-globe-americas"></i>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center g-0">
            <Col lg={6} className="order-lg-2 p-5">
              <div className="differential-content">
                <h2 className="section-title">Transparência, Consolidação e Controle</h2>
                <p className="section-text">
                  Nossos clientes acompanham seus investimentos sob nossa consultoria em tempo real 
                  com total transparência e amplamente consolidados. Mesmo que estejam custodiados 
                  em diferentes instituições financeiras.
                </p>
              </div>
            </Col>
            <Col lg={6} className="order-lg-1 d-none d-lg-block">
              <div className="differential-icon-large">
                <i className="bi bi-shield-check"></i>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Final */}
      <section className="cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h2 className="cta-title">Pronto para começar?</h2>
              <p className="cta-text">
                Entre em contato para conhecer nossos planos e ter acesso à nossa plataforma de consultoria.
              </p>
              <p className="cta-contact">
                <a href="mailto:leonardo.leite@itaunaconsultoria.com.br">leonardo.leite@itaunaconsultoria.com.br</a>
                {' '}ou{' '}
                <a href="tel:+552139581228">(21) 3958-1228</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
